import { defineMessages } from 'react-intl';

export default defineMessages({
  billerEdit: {
    id: 'billerEdit',
    defaultMessage: 'Edit Biller Detail',
  },
  billerEditCreateForm: {
    id: 'billerEdit.newForm',
    defaultMessage: 'Create New Form',
  },
  billerEditBreadcrumb: {
    id: 'billerEdit.billerEditBreadcrumb',
    defaultMessage: 'Billers',
  },
  billerEditBreadcrumb2: {
    id: 'billerEdit.billerEditBreadcrumb2',
    defaultMessage: 'edit New',
  },
  billerEditMandatory: {
    id: 'billerEdit.mandatoryField',
    defaultMessage: 'Mandatory Field',
  },
});
